export enum Roles {
    ADMIN = "ApplicationAdministrator",
    APP_ADMIN = "BusinessEntityAdministrator",
    SUB_USER = "ApplicationUser",
    GUEST = "Guest",
}
  
export enum Permission {
    ALLOW_ALL_FEATURES = "allow_all_features",
    CAN_EDIT_USERS = "can_edit users",
    CAN_EDIT_BUCKET = "can_edit_bucket",
    READ_ONLY = "read_only"
}

 
 
 
 
 